/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const PAGE_VIEWS_TABLE_STRINGS = {
  heading: '50 most viewed pages',
  pageViews: 'Page views',
  totalAmount: 'Total amount of page views in the last {{days}} days',
};
